import React from "react"
import Panel, { Content, CommandBar, Command, Search } from "../Panel"
import { QueryParams } from "../QueryParamsContainer"
import { Table, Image, Button, Label } from "semantic-ui-react"
import Observer from "react-intersection-observer"
import sizes from "../helpers/semantic-ui-sizes"
import { push } from "../history"

const Songs = props => (
  <QueryParams>
    {queryParams => (
      <Panel title="Songs">
        <CommandBar>
          <Command fluid>
            <Search
              value={queryParams.params.songsQuery || ``}
              onChange={songsQuery => queryParams.update({ songsQuery })}
            />
          </Command>
        </CommandBar>
        <Content
          style={{ padding: 0 }}
          loading={props.songs.isFetching}
          loadingText="Loading songs"
        >
          <Table basic="very" selectable style={{ marginTop: 0 }}>
            <Table.Body>
              {props.songs.data.map(item => (
                <Table.Row
                  key={item.id}
                  active={props.location.pathname.indexOf(item.id) !== -1}
                  onClick={() => {
                    push(`${ props.match.path }/${ item.id }`)
                  }}
                  style={{ cursor: `pointer` }}
                >
                  <Table.Cell
                    textAlign="left"
                    style={{
                      paddingLeft: `16px`,
                      width: `1%`,
                      whiteSpace: `nowrap`,
                      verticalAlign: `top`,
                    }}
                  >
                    {item.image ? (
                      <Image
                        size="mini"
                        src={item.image.url + `?width=${ sizes.mini }`}
                        style={{
                          marginTop: `auto`,
                          marginBottom: `auto`,
                        }}
                      />
                    ) : (
                      <div
                        className="ui tiny image"
                        style={{
                          width: `${ sizes.mini }px`,
                          height: `${ sizes.mini }px`,
                          border: `dashed 2px rgb(140,140,140)`,
                        }}
                      />
                    )}
                  </Table.Cell>
                  <Table.Cell style={{ paddingLeft: `16px` }}>
                    <div
                      style={{
                        minHeight: `40px`,
                        display: `flex`,
                        flexDirection: `column`,
                        justifyContent: `center`,
                      }}
                    >
                      <span>{item.name}</span>
                      <small>{item.description}</small>
                    </div>
                  </Table.Cell>
                  <Table.Cell
                    textAlign="right"
                    style={{
                      paddingRight: `16px`,
                      width: `1%`,
                      whiteSpace: `nowrap`,
                    }}
                  >
                    {item.featured ? <Label>Featured</Label> : null}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
          {props.songs.next && (
            <Observer
              onChange={inView =>
                inView && !props.songs.isFetching && props.songs.fetch(true)
              }
              rootMargin="610px"
            >
              <div
                style={{
                  width: `100%`,
                  display: `flex`,
                  justifyContent: `center`,
                  padding: `3em`,
                }}
              >
                <Button
                  basic
                  content="Load more..."
                  onClick={() => props.songs.fetch(true)}
                  loading={props.songs.isFetchingNext}
                />
              </div>
            </Observer>
          )}
          {!props.songs.next && !props.songs.isFetching && (
            <div
              style={{
                display: `flex`,
                justifyContent: `center`,
                alignItems: `center`,
                minHeight: `122px`,
              }}
            >
              <Button
                basic
                onClick={() =>
                  push(
                    `/songs/new`,
                    queryParams.params.songsQuery &&
                      queryParams.params.songsQuery.length > 0
                      ? { name: queryParams.params.songsQuery }
                      : {}
                  )
                }
              >
                {queryParams.params.songsQuery &&
                queryParams.params.songsQuery.length > 0 ? (
                  <span>
                    Add{` `}
                    <strong>{queryParams.params.songsQuery}</strong>
                  </span>
                ) : (
                  `Add missing song`
                )}
              </Button>
            </div>
          )}
        </Content>
      </Panel>
    )}
  </QueryParams>
)

export default Songs
